import { createAction, props } from "@ngrx/store";
import { TramiteStatus } from "./tramite-status.model";

export const tramiteStatusLoadRequest = createAction(
  "[TramiteStatus] Load Request"
);

export const tramiteStatusLoadFailure = createAction(
  "[TramiteStatus] Load Failure",
  props<{ error: Error }>()
);

export const tramiteStatusLoadSuccess = createAction(
  "[TramiteStatus] Load Success",
  props<{ items: TramiteStatus[] }>()
);
